<template>
	<transition>
		<div class="content-wrapper">
			<!-- Content Header (Page header) -->
			<!-- Main content -->
			<section class="content">
				<!-- Default box -->
				<div class="box">
				<div class="box-header with-border">
					<div class="heading-cart">
						<div class="col-lg-6 col-md-6 no-padding">
							<h3 class="box-title">Direct direct-campaigns</h3>
							<h3 class="box-title text-danger animated flash config-notif" v-if="selectedBucketNameToImportConfig"><b> Imported config from {{selectedBucketNameToImportConfig}} Bucket. Click save to use the config.</b></h3>
						</div>
						<div class="col-lg-6 col-md-6 no-padding">
							<a href="#" class="btn-success" style="background:#5cb85c;margin-right:175px;">Save</a>
							<div style="display:inline-block;float:right;padding: 0px;margin: 0px;">
								<el-dropdown trigger="click" @command="selectBucketModule">
									<el-button type="primary" size="mini" :title="(selectedBucketNameToImportConfig) ? selectedBucketNameToImportConfig : 'Import Config'">
									{{(selectedBucketNameToImportConfig) ? selectedBucketNameToImportConfig : 'Import Config'}}<i class="el-icon-arrow-down el-icon--right"></i>
									</el-button>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item v-for="(bucket, index) in bucketListForModuleConfig" :command="index">{{bucket.bucketName}}</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
								<button class="btn btn-sm btn-default btn-circle" v-if="selectedBucketNameToImportConfig" v-on:click.prevent="removeSelectedModuleConfig()"><i class="el-icon-close"></i></button>
							</div>
						</div>
					</div>
				</div>
					<div class="box-body">
						<h5>Enter Name for Direct Campaign</h5>
						<p :class="{ 'control': true }">
							<el-input class = "publishers-input" v-validate="'required'" data-vv-delay="1000" :class="{'input': true, 'is-danger': errors.has('name') }" name="name" type="text" placeholder="Name" v-model="credentials.name"></el-input>
							<span v-show="errors.has('name')" class="help is-danger">{{ errors.first('name') }}</span>
						<hr>
						<h5>Select Ad Unit</h5>
						<el-select v-model="credentials.adunit" @change="setSelectedAdUnit()" placeholder="Select a adunit" filterable multiple remote :remote-method="getAdunits" :loading="loading">
							<el-option v-for="adunit in adunits" :key="adunit.ad_unit_id" :label="adunit.ad_unit_name" :value="adunit.id"></el-option>
						</el-select>
						<hr>
						<div class="block">
							<h5 class="demonstration">Specify Start Date and End Date</h5>
							<el-date-picker
								v-model="credentials.date"
								type="datetimerange"
								range-separator="To"
								start-placeholder="Start date"
								end-placeholder="End date"></el-date-picker>
						</div>
						<hr>
						<h5>Direct Campaign Type</h5>
						<el-select v-model="credentials.line_item_type" placeholder="Select">
							<el-option
								v-for="item in options"
								:key="item.value"
								:label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<hr>
						<div v-if="credentials.line_item_type == 'STANDARD'">
							<h5>Enter Quantity</h5>
							<p :class="{ 'control': true }"></p>
							<el-input class = "publisher-input" v-validate="'required'" data-vv-delay="1000" :class="{'input': true, 'is-danger': errors.has('number') }" name="number" type="number" placeholder="Contact Number" v-model="credentials.primary_goal_units"></el-input>
							<span v-show="errors.has('number')" class="help is-danger">{{ errors.first('number') }}</span>
							<el-select v-model="credentials.primary_goal_unit_type" placeholder="Select">
								<el-option
									v-for="item in QuantityOptions"
									:key="item.value"
									:label="item.label"
									:value="item.value"></el-option>
							</el-select>
							<hr>
							<h5>Enter Rate</h5>
							<p :class="{ 'control': true }"></p>
							<el-input class = "publisher-input" v-validate="'required'" data-vv-delay="1000" :class="{'input': true, 'is-danger': errors.has('number') }" name="number" type="number" placeholder="Contact Number" v-model="amount">% of total impressions </el-input>
							<span v-show="errors.has('number')" class="help is-danger">{{ errors.first('number') }}</span>
							<hr>
						</div>
						<div v-else-if = "credentials.line_item_type == 'SPONSORSHIP'">
							<h5>Enter Quantity % of total impressions</h5>
							<p :class="{ 'control': true }"></p>
							<el-input class = "publisher-input" v-validate="'required'" data-vv-delay="1000" :class="{'input': true, 'is-danger': errors.has('number') }" name="number" type="number" placeholder="Contact Number" v-model="credentials.primary_goal_units">% of total impressions </el-input>
							<span v-show="errors.has('number')" class="help is-danger">{{ errors.first('number') }}</span>
							<hr>
							<h5>Enter Rate</h5>
							<p :class="{ 'control': true }"></p>
							<el-input class = "publisher-input" v-validate="'required'" data-vv-delay="1000" :class="{'input': true, 'is-danger': errors.has('number') }" name="number" type="number" placeholder="Contact Number" v-model="amount">% of total impressions </el-input>
							<span v-show="errors.has('number')" class="help is-danger">{{ errors.first('number') }}</span>
							<el-select v-model="credentials.cost_type" placeholder="Select">
								<el-option
									v-for="item in SponsorshipOptions"
									:key="item.value"
									:label="item.label"
									:value="item.value"></el-option>
							</el-select>
							<hr>
						</div>
						<div class = "col-md-12 creativeSnippet" v-if="credentials.line_item_type == 'STANDARD' | 'SPONSORSHIP'">
							<h5>Enter the Creative</h5>
							<div v-for="(row, index) in rows">
								<div class = "col-md-8 creativeSnippet">
									<el-input
										type="textarea"
										:autosize="{ minRows: 2, maxRows: 4}"
										placeholder="Please input"
										v-model="row.title"></el-input>
								</div>
								<div class = "col-md-4 creativeSnippet">
									<button @click ="removeElement(index)" class="btn btn-sm btn-danger btn-circle">
										<i class="el-icon-close"></i>
									</button>
									<!-- <a v-on:click="removeElement(index);" style="cursor: pointer">Remove</a> -->
								</div>
							</div>
							<div class = "col-md-12">
								<el-button type="success" @click="addRow">Add Creative</el-button>
								<hr>
							</div>
						</div>
						<el-button type="success" @click="submit()">Submit</el-button>
					</div>
					<!-- /.box-body -->
				</div>
				<!-- /.box -->
			</section>
			<!-- /.content -->
		</div>
	</transition>
</template>
<script>
	import axios from 'axios'
	export default {
	  data() {
	    return {
	    	module : 'dc',
	    	rows: [],
	    	adunits: [],
	    	credentialId: [],
	    	selectedAdUnits: [],
	    	bucketListForModuleConfig : [],
			selectedBucketToImportConfig : undefined,
			selectedBucketNameToImportConfig : undefined,
	    	adunits: [],
	      credentials: {
	        date: '',
	        name: '',
	        primary_goal_goal_type: '',
	        cost_type: 'CPM',
	        primary_goal_units: '',
	        line_item_type: '',
	        primary_goal_unit_type: 'IMPRESSIONS',
	        pub_id: this.$route.params.uuid,
	        creative: '',
	        adunit: []
	      },
	      formData: {
					adunit: []
		   },
	      amount: '',
	      options: [{
	          value: 'STANDARD',
	          label: 'STANDARD'
	        }, {
	          value: 'SPONSORSHIP',
	          label: 'SPONSORSHIP'
	        }],
	      QuantityOptions: [{
	          value: 'IMPRESSIONS',
	          label: 'IMPRESSIONS'
	        }, {
	          value: 'CLICKS',
	          label: 'CLICKS'
	        }],
	      SponsorshipOptions: [{
	          value: 'CPD',
	          label: 'CPD'
	        }, {
	          value: 'CPM',
	          label: 'CPM'
	        },{
	          value: 'CPC',
	          label: 'CPC'
	        }],
	        value: '',
	        value3: [new Date(2000, 10, 10, 10, 10), new Date(2000, 10, 11, 10, 10)],
	        value4: ''
	    }
	  },
	  created: function() {
	    this.$nextTick(function() {
	    	axios.all([
				axios.get(BASE_URL +'v1/domain/'+ this.$route.params.domId +'/dfp-credentials/'),
			])
			.then(axios.spread((creadentialId, selectedAdUnits) => {
				this.credentialId = creadentialId.data.id;
			}))

			this.getListOfBucketConfig();
	
	    })
	  },
	  methods: {
		removeSelectedModuleConfig(){
				this.selectedBucketToImportConfig = undefined;
				this.selectedBucketNameToImportConfig = undefined;
				
		},
	  	getListOfBucketConfig : function(){
				axios.post(BASE_URL + 'v1/get_bucket_config_list/', {bucketId : this.$route.params.bucketId, module : this.module})
				.then(response => {
					if (response.data.response_data.status) {
						this.bucketListForModuleConfig = response.data.response_data.bucket_list;
					}
				})
				.catch(e => {
					console.log();
				});
			},
		selectBucketModule(index){
			this.selectedBucketToImportConfig = this.bucketListForModuleConfig[index].id;
			this.selectedBucketNameToImportConfig = this.bucketListForModuleConfig[index].bucketName;
			if (this.selectedBucketToImportConfig !== null && this.selectedBucketToImportConfig !== undefined) {
				console.log(this.selectedBucketToImportConfig)
				this.getDFPConfig(this.selectedBucketToImportConfig);
				this.notificationMsg('Success', 'Imported Successfully! click save to use this config.');
			}
		},
		getDFPConfig: function(bucketID){
			axios.all([
				axios.get(BASE_URL + 'v1/publishers/' + this.$route.params.uuid +  '/domains/' + this.$route.params.domId + '/buckets/'+ this.$route.params.bucketId +'/direct-campaign/'),
				])
				.then(axios.spread((data) => {
					console.log(data);
				}))
		},
		notificationMsg : function(type = 'Error', msg){
				this.$notify({
					title: type,
					message: (msg) ? msg : 'Oops Something went wrong!',
					type: type.toLowerCase()
				});
			},
	  	getAdunits(query){
			if(query){
				axios.all([
					axios.get(BASE_URL +'v1/search-ad-unit/'+ this.$route.params.domId +'/?query='+ query),
				])
				.then(axios.spread((data) => {
					this.adunits = data.data;
				}))
			}
		},
	  	setSelectedAdUnit(){
			setTimeout(() => {
				if(this.formData.adunit && this.formData.adunit.length > 0){
					axios.get(BASE_URL +'v1/get-ad-unit/'+ this.credentialId +'/bucket/'+ this.$route.params.bucketId +'/?query='+ JSON.stringify(this.formData.adunit))
					.then((data) => {
						this.selectedUnits = data.data;
					})
				}
				});
			},
	    addRow(){
	      if(this.rows.length < 5){
	          this.rows.push({
	              title: "",
	          }); 
	      }else{
	      	this.$notify({
					title: "Creatives Limit Exceeded",
					message: "You can only have 5 creatives.",
					type: "warning"
			 });
	      }

	     },
	    removeElement(index) {
          this.rows.splice(index, 1);
     	 },
	    submit() {
	      this.credentials.micro_amount = this.convert_to_micro(this.amount)
	      if(this.credentials.line_item_type == "STANDARD"){
	        this.credentials.primary_goal_goal_type = "LIFETIME";
	      }else if(this.credentials.line_item_type == "SPONSORSHIP"){
	        this.credentials.primary_goal_goal_type = "DAILY";
	      }
	      let creatives_dfp = []
	      this.rows.forEach(function(value, index){
	      	creatives_dfp.push({creative: value.title});
	      });
	      console.log(creatives_dfp)

	      axios.post(BASE_URL + 'v1/publishers/'+ this.$route.params.uuid +'/domains/'+ this.$route.params.domId +'/direct-campaigns/line-items/', {
	      line_item_name: this.credentials.name,
	      cost_type: this.credentials.cost_type,
	      primary_goal_units: this.credentials.primary_goal_units,
	      line_item_type: this.credentials.line_item_type,
	      primary_goal_unit_type: this.credentials.primary_goal_unit_type,
	      micro_amount: this.credentials.micro_amount,
	      primary_goal_goal_type: this.credentials.primary_goal_goal_type,
	      start_date: this.credentials.date[0],
	      end_date: this.credentials.date[1],
	      creatives: creatives_dfp,
	      ad_units: this.credentials.adunit,
	        })
	        .then(response => {
	           this.$notify({
					title: "Direct Campaign Created",
					message: "Direct Campaign Created",
					type: "success"
			 	});
	        })
	        .catch(error => {
	        	this.$notify({
					title: "Empty/Invalid Fields",
					message: "Please fill all the details",
					type: "warning"
			 	});
	        })
	
	    },
	    convert_to_micro(amount){ 
	      amount = amount * Math.pow(10, 6);
	      return amount;
	    }
	  }
	}
	
										
</script>
<style scoped>
	
	.btn-circle{
		border-radius: 100px !important;
	}

	.el-select{
		display: block;
	}
	
	.creativeSnippet {
		padding-bottom: 20px;
    	padding-right: 20px;
	}
	.content {
		padding-top: 100px;
	}
	.publisher-input {
		width: 50%;
	}

	input[type=number]::-webkit-outer-spin-button,
	input[type=number]::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
	input[type=number] {
		-moz-appearance:textfield;
	}
	md-12, .col-md-12 {
		padding-left: 0px; 
	}
	md-8, .col-md-8 {
		padding-left: 0px; 
	}
	.flash{
		background: none !important;
	}
</style>


// WEBPACK FOOTER //
// CreateDirectCampaign.vue?0ae0fe7e